// extracted by mini-css-extract-plugin
export var actions = "_t3-4";
export var item = "_t3-1";
export var price = "_t3-3";
export var quantity = "_t3-2";
export var table = "_t3-0";